export const FILTER_MODIFIED_OPTIONS = {
  CLAIMS_MONTH: "claimsMonth",
  CLAIMS_YEAR: "claimsYear",
  CLAIMS_DATE_RANGE: "claimsDateRange",
  CLAIMS_RUNOUT: "claimsRunout",
  CLAIMS_PLANS: "claimsPlans",
  CLAIMS_SUBSIDIARIES: "claimsSubsidiaries",
  DOCUMENT_TYPE: "documentType",
  PEOPLE_MONTH: "peopleMonth",
  PEOPLE_YEAR: "peopleYear",
  RESET: "reset"
};

export const USER_EVENTS = {
  CENSUS_DOWNLOADED: "censusDownloaded",
  DASHBOARD_DOWNLOADED: "Dashboard Downloaded",
  DASHBOARD_LOADED: "Dashboard Loaded",
  DASHBOARD_TILE_DOWNLOADED: "Dashboard Tile Downloaded",
  DASHBOARD_RUN: "Dashboard Run",
  DOCUMENT_DOWNLOADED: "documentDownloaded",
  EMERGENCY_ADD_EXITED: "emergencyAddExited",
  EMERGENCY_ADD_FAILED: "emergencyAddFailed",
  EMERGENCY_ADD_INITIATED: "emergencyAddInitiated",
  EMERGENCY_ADD_SUCCEEDED: "emergencyAddSucceeded",
  FILTER_CHANGED: "filterChanged",
  LOGOUT_SUBMIT: "logoutSubmit",
  NON_EMERGENCY_ADD_SELECTED: "nonEmergencyAddSelected",
  PAGE_ENTERED: "pageEntered",
  PASSWORD_CHANGE_ATTEMPTED: "passwordChangeAttempted",
  PASSWORD_CHANGE_SUCCESS: "passwordChangeSuccess",
  PEOPLE_SEARCH_FAILED: "peopleSearchFailed",
  PEOPLE_SEARCHED: "peopleSearched",
  SEND_INVITE: "sentInvite",
  SHOW_LESS_SELECTED: "showLessSelected",
  SHOW_MORE_SELECTED: "showMoreSelected",
  SMALL_DATA: "smallDataSetViewed",
  TEAM_MEMBER_ADDED: "teamMemberAdded",
  TEAM_MEMBER_EDITED: "teamMemberEdited",
  TEAM_MEMBER_REMOVED: "teamMemberRemoved",
  CLAIM_SECTION_VIEWED: "Claim Section Viewed",
  ACCUMULATOR_VIEWED: "Accumulator Viewed",
  BENEFIT_LIMIT_VIEWED: "Benefit Limit Viewed"
};
